<template>
  <div class="animated fadeIn">
    <div class="page-header d-flex">
      <h4 class="page-title">
        <i class="fas fa-user-alt"></i>
        그룹 목록
      </h4>
      <ul class="breadcrumbs ml-auto">
        <li class="nav-home mr-1">
          <a href="#">
            <i class="fas fa-home text-muted"></i>
          </a>
        </li>
        <li class="nav-item">
          <a class="font_15" href="#">관리</a>
        </li>
        <li class="separator">
          <i class="flaticon-right-arrow"></i>
        </li>
        <li class="nav-item">
          <a class="font_15 font-weight-bold" href="#">그룹</a>
        </li>
      </ul>
    </div>
    <!--//-------------------------------------------------------------------------검색조건-->
    <!-- detail search start -->
    <b-card v-show="so.adv">
      <b-row>
        <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
          <label class="col-form-label" for="opt_date">가입 날짜</label>
        </b-col>
        <b-col class="col-xl-4 col-md-12 d-flex align-self-center">
          <b-form-group>
            <b-button class="md-2 ml-1" size="sm" variant="outline-primary" @click="set_sd('')"><i class="fa fa-remove"></i></b-button>
            <b-button class="md-2" size="sm" variant="primary" @click="set_sd('-1d')">-1일</b-button>
            <b-button class="md-2" size="sm" variant="primary" @click="set_sd('-1w')">-1주</b-button>
            <b-button class="md-2" size="sm" variant="primary" @click="set_sd('-1m')">-1달</b-button>
            <b-button class="md-2" size="sm" variant="primary" @click="set_sd('w')">1주</b-button>
            <b-button class="md-2" size="sm" variant="primary" @click="set_sd('m')">1달</b-button>
            <b-form inline class="mt-2">
            <date-picker @change="refresh" v-model="so.opt.joined_at_sd" style="width: 140px" :lang="custom.lang.ko" :confirm="false" :first-day-of-week="1"></date-picker>
            ~
            <date-picker @change="refresh" v-model="so.opt.joined_at_ed" style="width: 140px" :lang="custom.lang.ko" :confirm="false" :first-day-of-week="1"></date-picker>
          </b-form>
          </b-form-group>
        </b-col>
        <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
          <label class="col-form-label" for="opt_group">서비스</label>
        </b-col>
        <b-col class="col-xl-4 col-md-12 align-self-center">
          <b-form-group>
            <select class="form-control" v-model="so.opt['service']">
              <option value="Basic">Basic</option>
              <option value="Pro">Pro</option>
              <option value="Premium">Premium</option>
            </select>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
          <label class="col-form-label mb-4" for="opt_E-mail">이메일</label>
        </b-col>
        <b-col class="col-xl-4 col-md-12 align-self-center">
          <b-form-group>
            <b-form-input @keydown.enter="refresh" type="text" id="opt_E-mail" v-model="so.opt['email']"></b-form-input>
          </b-form-group>
        </b-col>
        <b-col v-if="partner" class="col-xl-2 col-md-12 d-flex align-self-center">
          <label class="col-form-label mb-4" for="opt_groupname">이름</label>
        </b-col>
        <b-col v-if="partner" class="col-xl-4 col-md-12 align-self-center">
          <b-form-group>
            <b-form-input @keydown.enter="refresh" type="text" id="opt_groupname" v-model="so.opt['groupname']"></b-form-input>
          </b-form-group>
        </b-col>
        <b-col class="col-xl-1 col-md-12 d-flex align-self-center">
          <label class="col-form-label mb-4" for="ph_search_alive">활성화</label>
        </b-col>
        <b-col class="col-xl-2 col-md-12 align-self-center">
          <b-form-group>
            <div class="checkbox-switch">
              <input type="checkbox" class="input-checkbox" v-model="so.opt['is_alive']" @change="change_alive">
              <div class="checkbox-animate disabled">
                <span class="checkbox-off">OFF</span>
                <span class="checkbox-on">ON</span>
              </div>
            </div>
          </b-form-group>
        </b-col>
        <b-col class="col-xl-1 col-md-12 d-flex align-self-center">
          <label class="col-form-label mb-4" for="ph_search_del">삭제 여부</label>
        </b-col>
        <b-col class="col-xl-2 col-md-12 align-self-center">
          <b-form-group>
            <div class="checkbox-switch">
              <input type="checkbox" class="input-checkbox" v-model="so.opt['is_del']" @change="change_del">
              <div class="checkbox-animate disabled">
                <span class="checkbox-off">OFF</span>
                <span class="checkbox-on">ON</span>
              </div>
            </div>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
          <label class="col-form-label" for="ph_search_opt_type">일치 유형</label>
        </b-col>
        <b-col class="col-xl-4 col-md-12 align-self-center mt-4">
          <b-form-group>
            <b-form-radio-group id="ph_search_opt_type" v-model="so.opt['match_type']" name="ph_search_opt_type">
              <b-form-radio value="and">모두 일치</b-form-radio>
              <b-form-radio value="or">최소 한개이상 일치</b-form-radio>
            </b-form-radio-group>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row class="float-right mr-2">
        <b-form-group>
          <b-button size="sm" variant="add" @click="refresh"> 찾기 </b-button>
          <b-button size="sm" variant="warning" @click="reset"> 초기화 </b-button>
          <b-button size="sm" variant="secondary" @click="search_opt"> 닫기 </b-button>
        </b-form-group>
      </b-row>
    </b-card>
    <!-- detail search end -->
    <div class="d-flex flex-wrap align-items-center">
      <b-col v-if="view_detail !== false" sm="2">
        <span class="badge badge_border_primary mb-2">전체 : <span style="padding-left: 1rem"></span>{{(model.total ? model.total : 0).toString().padStart(4, nbsp) | number}}</span>
        <br>
        <span class="badge badge_border_info mb-2">사용 : <span style="padding-left: 1rem"></span>{{(model.enable ? model.enable : 0).toString().padStart(4, nbsp) | number}}</span>
        <br>
        <span class="badge badge_border_warning mb-2">삭제 : <span style="padding-left: 1rem"></span>{{(model.disable ? model.disable : 0).toString().padStart(4, nbsp) | number}}</span>
      </b-col>
      
      <b-col :sm="view_detail !== false ? 10 : 12" class="md-10 d-flex flex-wrap align-items-center">
        <b-input-group size="sm">
          <div class="mr-auto mb7"></div>
          <div class="mr-2 mb7 mt-2">
            <button class="btn btn-icon mr-1" style="border-color: #e4e7ea;"  @click="refresh()">
              <i class="fas fa-sync-alt"></i>
            </button>
            <button class="btn btn-icon mr-1" style="border-color: #e4e7ea;" @click="reset()">
              <i class="fas fa-times"></i>
            </button>
          </div>
          <div class="mr-2 mb7">
            <select class="form-control" :disabled="so.adv" :text="so.skt || '찾기'" size="sm" v-model="so.sk" name="sel1" id="sel1" @change="sv_reset">
              <option disabled value="">검색</option>
              <option value="service">서비스</option>
              <option value="groupname">이름</option>
            </select>
          </div>
          <div class="mr-2 mb7">
            <select class="form-control" :disabled="so.adv" v-if="so.sk == 'service'" @change="refresh" v-model="so.sv">
              <option v-for="(item, index) in codes.service_name" :key="index" :value="item">{{item}}</option>
            </select>
          </div>
          <div class="mr-2 mb7">
            <input type="text" class="form-control col-xl-12" name="input" id="input" v-if="so.sk != 'service'" :disabled="so.adv" v-model="so.sv" @keyup.enter="refresh()">
          </div>
          <div class="mb7">
            <button class="btn btn-icon1 mr-1 mt-1" @click="refresh()">
              <i class="fas fa-search"></i>
            </button>
            <!-- search detail
            <button class="btn btn-icon2" @click="search_opt">
              <i class="fas fa-search-plus" :class="{'fa-search-plus': !so.adv, 'fa-search-minus': so.adv }"></i>
            </button> -->
          </div>
        </b-input-group>
        <br>
        <b-input-group size="sm">
          <div class="mr-auto mb7"></div>
          <div class="mt-2">
            <b-checkbox @change="refresh" class="ml-3 mt-1" v-model="hide_del">삭제된 항목 숨기기</b-checkbox>
          </div>
          <div class="mb7 mr-2 mt-2">
            <button type="button" class="btn btn-sm btn-addition" tabindex="4" v-if="has_permissions()" @click="addWithPartner">
              등록
            </button>
          </div>
          <div class="mb7">
            <select class="form-control" name="sel2" id="sel2" v-model="so.perPage" @change="refresh">
              <option disabled value="15">표시되는 개수 : 기본 15개</option>
              <option value=10>10</option>
              <option value=50>50</option>
              <option value=100>100</option>
            </select>
          </div>
        </b-input-group>
      </b-col>
    </div>
    <!--//-------------------------------------------------------------------------검색조건-->
    <!--//-------------------------------------------------------------------------리스트출력-->
    <div class="reg_card">
      <div class="reg_card_body">
        <div class="table-responsive">
          <b-table class="table table_add table-striped" hover striped responsive="sm" ref="_list"
            show-empty empty-text="관련된 정보가 없어요."
            :items="getItems" :fields="fields" :current-page="so.currentPage" :per-page="so.perPage" :sortBy="so.sk" @row-clicked="goDetail" style="cursor:pointer;">
            <template slot="id" slot-scope="row">{{startRow - row.index}}</template>
            <template slot="joined_at" slot-scope="row">{{row.item.joined_at | sdate }}</template>
            <template slot="is_alive" slot-scope="row">
              <b-badge :variant="row.item.is_del ? 'danger' : (row.item.is_alive ? 'success' : 'secondary')">{{row.item.is_del ? '삭제' : (row.item.is_alive ? 'On' : 'Off')}}</b-badge>
            </template>
            <template slot="groupname" slot-scope="row">
              <del v-if="row.item.is_del">{{row.item.groupname }}</del>
              <span v-else>{{row.item.groupname ? row.item.groupname : '-' }}</span>
            </template>
            <template slot="count" slot-scope="row">사용자 : {{row.item.count }}</template>
            <template slot="service" slot-scope="row">
              <!-- <b-badge :variant="row.item.service === 'Basic' ? 'outline-info' : (row.item.service ? 'success' : 'secondary')"> {{row.item.service ? row.item.service : '-'}} </b-badge> -->
              <b-badge :variant="row.item.service === 'Basic' ? 'info' : (row.item.service ? 'success' : 'secondary')"> {{row.item.service ? row.item.service : '-'}} </b-badge>
            </template>
            <template slot="count" slot-scope="row">{{row.item.count | number }}</template>
          </b-table>              
        </div>
      </div>
    </div>
    <!--//-------------------------------------------------------------------------리스트출력-->
    <!--//-------------------------------------------------------------------------Pagination-->
    <div class="mt30">
      <b-pagination class="pagination justify-content-center" :total-rows="getRowCount()" :per-page="so.perPage" v-model="so.currentPage" :limit="10" prev-text="<" next-text=">"  />
    </div>
    <!--//-------------------------------------------------------------------------Pagination-->
  </div>
</template>

<script>
  import App from './app.js'; export default Object.assign({}, App);
</script>